require("!!C:\\projects\\truBooking\\vendor-admin-portal\\node_modules\\script-loader\\addScript.js")(require("!!C:\\projects\\truBooking\\vendor-admin-portal\\node_modules\\raw-loader\\index.js!C:\\projects\\truBooking\\vendor-admin-portal\\node_modules\\jquery\\dist\\jquery.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jquery/dist/jquery.js
// module id = 704
// module chunks = 2